import type { Action } from 'redux';
import type { IAdLink } from '../../../../../../shared/types';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const BulkCreateAdLinks = new ReduxAsyncAction<
  'BULK_CREATE_AD_LINKS',
  { templateId: string; links: IAdLink[]; collectionName?: string },
  Record<string, any>
>('BULK_CREATE_AD_LINKS');

BulkCreateAdLinks.registerRequest(async ({ templateId, links, collectionName }): Promise<Record<string, any>> => {
  try {
    const payload = collectionName ? { templateId, links, collectionName } : { templateId, links };

    const response = await dash_api.post('/v1/linkhub/ad/bulk', payload);

    return response;
  } catch (error) {
    NotificationActions.showNotification('Failed to bulk create ad links.', 'error');

    throw error;
  }
});

export const BULK_CREATE_AD_LINKS = BulkCreateAdLinks.actionNamespaceConstants;
export const bulkCreateAdLinks = BulkCreateAdLinks.request;

export type BulkCreateAdLinksResponseAction = Action<typeof BULK_CREATE_AD_LINKS.response> & {
  data: Record<string, any>;
};
